import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/yanre/Reveal";
import { track } from "@/lib/track";
import { useLocale } from "@/i18n/LocaleContext";

// SECTION — Your Space. Your Project. Studio designed around real constraints.
const FACTORS = [
  ["pts.space.f0", "Available floor area", null, null],
  ["pts.space.f1", "Training methodology", null, null],
  ["pts.space.f2", "Number of simultaneous clients", null, null],
  ["pts.space.f3", "Investment level", null, null],
  ["pts.space.f4", "Buy Direct From The Factory", "pts.space.f4d", "Commercial-grade YANRE equipment without unnecessary reseller layers."],
  ["pts.space.f5", "Ready-To-Operate Studio", "pts.space.f5d", "Professional equipment, intelligent layout and a complete studio concept ready for business."],
];

export const PTSpace = () => {
  const { t } = useLocale();
  return (
    <section className="section-dark py-24 lg:py-32" data-testid="pt-space-section">
      <div className="container-edge">
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-10 bg-signal" />
            <span className="overline">{t("pts.space.label", "Space Planning")}</span>
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="max-w-4xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
            {t("pts.space.h2a", "Your space.")}{" "}
            <span className="text-signal">{t("pts.space.h2b", "Your project.")}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-titanium/75 sm:text-lg">
            {t(
              "pts.space.copy",
              "No two studios are the same. Your equipment selection and layout are designed around your reality — not a fixed catalog bundle."
            )}
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px border border-carbon-700 bg-carbon-700 sm:grid-cols-2 lg:grid-cols-3" data-testid="pt-space-grid">
          {FACTORS.map(([key, fallback, descKey, descFallback], i) => (
            <div key={key} className="bg-carbon-950 p-7" data-testid={`pt-space-factor-${i}`}>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-signal">0{i + 1}</p>
              <p className="mt-3 font-display text-lg font-bold uppercase tracking-wide text-white">{t(key, fallback)}</p>
              {descKey && (
                <p className="mt-2 text-sm font-light leading-relaxed text-titanium/60">{t(descKey, descFallback)}</p>
              )}
            </div>
          ))}
        </div>

        <Reveal delay={0.15}>
          <a
            href="#studio-project"
            onClick={() => track("cta_start_project", { placement: "space_section", page: "personal-trainer-studio" })}
            className="btn-signal group mt-12"
            data-testid="pt-space-cta"
          >
            {t("pts.space.cta", "Start My Studio Project")}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>
    </section>
  );
};
